import { Stack, Switch, Typography } from '@mui/material';
import React, { useState } from 'react';

interface AutoApplicationsActionProps {
  field: string;
  value: boolean;
  isDisable: boolean | undefined;
  updateProfile: (data: { [key: string]: boolean }) => void;
}

const AutoApplicationsAction: React.FC<AutoApplicationsActionProps> = ({
  field,
  value,
  isDisable,
  updateProfile,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(value);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    setIsChecked(checked);
    updateProfile({ [field]: checked });
  };

  return (
    <Stack direction="row" spacing={3} alignItems="center" sx={{ mt: 2 }}>
      <Switch
        onChange={handleSwitchChange}
        size="medium"
        checked={isChecked}
        disabled={isDisable}
      />
      <Typography sx={{ whiteSpace: 'nowrap' }}>
        {isChecked ? 'ON' : 'OFF'}
      </Typography>
    </Stack>
  );
};

export default AutoApplicationsAction;
